<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/demandHome/demandIndex' }">首页</el-breadcrumb-item>
			  <el-breadcrumb-item>需求详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.name}}</h3>
					<p>发布时间：{{datails.create_time}}</p>
					<ul class="hangyeul">
						<li class="hangyeli" v-for="(i,index) in datails.industries" :key='index'>{{i}}</li>
					</ul>
				</div>
				<div class="leftsidebarDox">
					<div class="invitdatails">
						<h4>需求详情</h4>
						<p>{{datails.description}}</p>
					</div>
					<div class="invitimg">
						<div class="invitimg1">
							<h4>需求详情</h4>
							<div>
								<img v-for="(i,indexs) in fileObjects" :src="i.url" v-if="i.type=='image'" :key='indexs'></img>
								<img v-for="(i,index) in  fileObjects" :src="i.url" v-if="i.type=='zip'" :key='index'></img>
								<img v-for="(i,index) in  fileObjects" :src="i.url" v-if="i.type=='ftp'" :key='index'></img>
							</div>
						</div>
						<div class="invitimg2">
							<h4>验收标准</h4>
							<div class="invitimg2_1">
								<div class="invitimg2_1_1">
									<img :src="datails.confirm_image" alt="" srcset=""/>
									<div>承认图</div>
								</div>
								<div class="invitimg2_1_1">
									<img :src="datails.produce_image" alt="" srcset=""/>
									<div>生产图</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="leftsidebarDox">
					<div style="width:100%;display:flex;justify-content:space-between;align-items: center;">
						<h4>服务方报价列表（{{datails.quotes_count}}/{{datails.quote_num}}）</h4>
						<span style="font-size: 14px;color: #999999;">
						    已有{{datails.quotes_count}}家服务商报价
						</span>
					</div>
					<div class="invitfrom">
						<ul class="invitTitle">
							<li style="width:278px;">服务方信息</li>
							<li style="width:207px;">附件</li>
							<li style="width:150px;">报价金额</li>
							<li style="width:91px;">交付周期</li>
							<li style="width:128px;">报价状态</li>
						</ul>
						<figure class="zanwu"  v-if="datails.quotes.length==0">
							<img src="@/assets/kong.png" alt="" srcset="" />
							<figcaption>暂无数据</figcaption>
						</figure>
						<ul class="invitUl" v-for="(s) in  datails.quotes">
							<li class="yaobiao1" style="width:278px;">
								<img :src="s.user.avatar" alt="" class="yaobiaotx">
								<div class="yaobiao1_1">
									<div class="yaobiao1_title">
										<p>{{s.user.nickname}}</p>
										<div v-if="s.is_invite==1">被邀标人</div>
									</div>
									<div class="yaobiao1_datails"> 
										<div>
											<img src="@/assets/caller.png" alt="" srcset="" v-for="(i) in  s.user.display_score"/>
											<span v-if="s.user.display_score>0" style="color: #E7AA00;" >{{s.user.display_score}}</span>
											<span v-if="s.user.display_score==0">暂无评分</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>接单:</p>
											<span>{{s.user.total_order_num}}</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>售后:</p>
											<span>{{s.user.aftersale_num}}</span>
										</div>
									</div>
									
								</div>
							</li>
							<li class="yaobiao2"  style="width:207px;">
								<img :src="g" alt="" srcset="" v-for="(g) in s.file" :key='i' />
								<div v-if="s.file.length==0"
								  style="width:100%;font-weight: 400;font-size:14px;color: #CCCCCC;height:100%;display:flex;align-items:center;">
								    暂无报价内容
								</div>
							</li>
							<li class="yaobiao3" style="width:150px;">
								<span>￥{{s.show_price || 0.00}}</span>
							</li>
							<li class="yaobiao4" style="width:91px;">
								<span>{{s.period_format}}</span>
							</li>
							<li class="yaobiao5" style="width:128px;" v-if="s.is_quote==1 && datails.q_id==''">
								<div v-if="datails.status==2 && datails.end_text !=4" @click="queding(s.q_id)">确认中标</div>
								<div v-if="datails.status==2 && datails.end_text ==4" style="background:#CCCCCC;">已超时</div>
								<div v-if="datails.status==1">已报价</div>
							</li>
							<li class="yaobiao5" style="width:128px;" v-if="s.is_quote==0 && datails.q_id=='' && s.status !=-1">
								<div style="background: #CCCCCC;">暂未报价</div>
							</li>
							<li class="yaobiao5" style="width:128px;" v-if="s.status ==-1">
								<div style="background: #CCCCCC;">已拒绝</div>
							</li>
							<li class="yaobiao5" style="width:128px;" v-if="s.is_quote==1 && datails.q_id !=''">
								<div v-if="s.is_select==1" style="background:#4DC800;">已中标</div>
								<div v-if="s.is_select==0" style="background:#CCCCCC;">未选报价</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="rightsidebar">
				<div class="rightShenhe">
					<h3 v-if="datails.status==1">报价中</h3>
					<h3 v-if="datails.status==0">审核中</h3>
					<h3 v-if="datails.status==-1">已驳回</h3>
					<p v-if="datails.status==0">平台审核中，请您耐心等待</p>
					<p v-if="datails.status==1" style="color:#FF5900;font-size:14px;">
						 报价剩余时间：<CountDown :endTime="datails.display_end_time*1000"></CountDown>
					</p>
					<div v-if="datails.status==2">
						<template v-if="datails.is_off==1">
							<h3 style="width:100%;text-align: center;">平台下架</h3>
							<p>下架原因：</p>
						</template>
						<template v-else-if="datails.end_text==5">
							<h3 style="width:100%;text-align: center;">已结束</h3>
							<p style="color:#FF5900;font-size:14px;">
								选标剩余时间：<CountDown :endTime="datails.choose_expire_time*1000"></CountDown>
							</p>
						</template>
						<template v-else>
							<h3 style="width:100%;text-align: center;">已结束</h3>
							<p v-if="datails.status==0">需求已结束，感谢您使用本平台</p>
						</template>
					</div>
				</div>
				<div class="rightStype yaobiao1" >
					<img :src="datails.user.avatar" alt="" class="yaobiaotx" style="width:52px;height:52px;">
					<div class="yaobiao1_1"  style="width:180px;">
						<div class="yaobiao1_title" style="width:100%;display:inline-block;">
							<p style="width:100%;">{{datails.user.nickname}}</p>
							<div style="position: inherit;background: initial;display: flex;align-items: center;">
								<img src="@/assets/caller.png" alt="" srcset="" v-for="(i) in  datails.user.display_score"/>
								<span v-if="datails.user.display_score==0">暂无评分</span>
								<span>{{datails.user.display_score}}</span>
							</div>
						</div>
						<div class="yaobiao1_datails"> 
							<div>
								<p>订单数量:</p>
								<span>{{datails.user.total_order_num}}</span>
							</div>
							<span class="shu1">|</span>
							<div>
								<p>售后:</p>
								<span>{{datails.user.aftersale_num}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { DemandDetail,chooseQuote } from '@/api/api'
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg,
		CountDown
	  },
	  data() {
	    return {
			typeindex: 0,
			datails: {},
			fileObjects: [],
			imageUrls: [],
			q_id:""
	    }
	  },
	  computed: {
	    // 从路由 query 接收 d_id（demandList 跳转时 ?d_id=xxx）
	    d_id() {
	      return this.$route.query.d_id || ''
	    }
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		getdatails(){
			DemandDetail(this.d_id,{}).then(res=>{
				this.datails = res.data.data || {}
				console.log(this.datails)
				const fileList = this.datails.file || []
				this.fileObjects = fileList.map(url => ({
				  url: url,
				  type: this.getFileType(url)
				}))
				// 提取所有图片的URL用于预览
				this.imageUrls = this.fileObjects
					.filter(item => item.type === 'image')
					.map(item => item.url)
			})
		},
		getFileType(url) {
		  const extension = url.split('.').pop().toLowerCase();
		  const typeMap = {
		    'jpg': 'image',
		    'jpeg': 'image',
		    'png': 'image',
		    'gif': 'image',
		    'zip': 'zip',
		    'rar': 'zip',
		    'ftp': 'ftp'  // 根据实际需求可调整
		  };
		  return typeMap[extension] || 'unknown';
		},
		handleSizeChange(){
			
		},
		handleCurrentChange(){
			
		},
		qiehuan(index){
			this.typeindex=index
		},
		queding(e){
			this.q_id=e
			
			this.$confirm('您确定要选择该服务商吗?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				    this.xuanzhong()
				}).catch(() => {
				         
				});
		},
		xuanzhong(){
			chooseQuote(this.d_id,{
				q_id:this.q_id
			}).then(res=>{
				if(res.status==200){
					this.pay(res.data.data)
				}
			})
		},
		pay(e){
			OrderPay({
				order_sn:e,
				pay_type:'NATIVE'
			}).then(res=>{
				this.getPay(res.data)
			})
		},
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:894px;
	}
	.rightsidebar{
		width:282px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle p{
		font-weight: 400;
		font-size: 16px;
		color: #666666 !important;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.hangyeul{
		width:100%;
		display:flex;
		flex-wrap:wrap;
	}
	.hangyeli{
		font-weight: 500;
		font-size: 14px;
		color: #4297FF;
		padding:2px 5px;
		box-sizing: border-box;
		margin-right:10px;
		margin-top:8px;
		background:#E3F0FF;
		border-radius: 4px 4px 4px 4px;
	}
	.invitdatails{
		width:100%;
	}
	.invitdatails p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
	}
	.invitimg{
		width:100%;
		display:flex;
		justify-content:space-between;
		margin-top:24px;
	}
	.invitimg1 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitimg2{
		width:352px;
	}
	.invitimg2_1{
		width:100%;
		display:flex;
		align-items:center;
		margin-top:0 !important;
	}
	.invitimg2_1_1{
		margin-right:16px;
		position: relative;
	}
	.invitimg2_1_1 img{
		margin-right:0 !important;
	}
	.invitimg2_1_1 div{
		width:100%;
		height:100%;
		position:absolute;
		top: 0;
		bottom: 0;
		display:flex;
		justify-content:center;
		align-items: center;
		margin-top:0 !important;
		border-radius:6px;
		background:rgba(255,255,255,0.3);
	}
	.invitimg1 div,.invitimg2 div{
		margin-top:12px;
	}
	.invitimg2 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitfrom{
		width:100%;
		border:1px solid #D2D8E8;
		border-radius:12px;
		margin-top:20px;
	}
	.invitTitle{
		width:100%;
		display:flex;
		border-bottom:1px solid #D2D8E8;
	}
	.invitTitle li{
		text-align:left;
		line-height:52px;
		padding:0px 10px;
		box-sizing: border-box;
	}
	.invitUl{
		width:100%;
		display:flex;
	}
	.yaobiao1{
		padding:16px 12px;
		box-sizing: border-box;
		display:flex;
	}
	.yaobiaotx{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-right:12px;
	}
	.yaobiao1_title{
		width:210px;
		position: relative;
	}
	.yaobiao1_title p{
		width:140px;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.yaobiao1_title div{
		width: 58px;
		height: 20px;
		background: rgba(255,74,78,0.15);
		border-radius: 4px ;
		text-align:center;
		line-height:20px;
		font-weight: 500;
		font-size: 12px;
		color: #E7AA00;
		position:absolute;
		right: 0;
		top: 0;
	}
	.yaobiao1_datails{
		display:flex;
		width:210px;
		margin-top:5px;
	}
	.yaobiao1_datails img{
		width:10px;
		height:10px;
		margin-right:0px;
	}
	.yaobiao1_datails p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.yaobiao1_datails span{
		font-weight: 400;
		font-size: 12px;
		color: #333333;
	}
	.yaobiao1_datails div{
		display:flex;
		align-items: center;
		padding: 0px 10px 0px 0px;
		box-sizing: border-box;
	}
	.shu1{
		font-size:10px;
		margin-right:10px;
	}
	.yaobiao2,.yaobiao3,.yaobiao4,.yaobiao5{
		display:flex;
		align-items: center;
		padding:16px 12px;
		box-sizing: border-box;
	}
	.yaobiao2 img{
		width:42px;
		height:42px;
		border-radius:8px;
		margin-right:5px;
	}
	.yaobiao3{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
	}
	.yaobiao4{
		font-weight: 400;
		font-size: 16px;
		color: rgba(51,51,51,0.9);
	}
	.yaobiao5 div{
		width: 80px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.rightShenhe{
		width: 282px;
		height: 133px;
		background: #FFFFFF;
		border-radius: 12px ;
		display:flex;
		flex-direction: column;
		justify-content:center;
		align-items: center;
	}
	.rightShenhe h3{
		font-weight: bold;
		font-size: 24px;
		color: #E7AA00;
		line-height:40px;
	}
	.rightShenhe p{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.rightStype{
		width: 282px;
		background: #FFFFFF;
		border-radius: 12px ;
		margin-top:24px;
	}
/* 	.yaobiao1_title div{
		width:100%;
		display:flex;
		align-items:center;
	} */
	.yaobiao1_title div>img{
		width:14px;
		height:14px;
		margin-right:2px;
	}
	.zanwu{
		width:100%;
        text-align: center;
		color: #666666;
		padding:20px 0px;
	}
	.zanwu img{
		width:180px;
		height:180px;
	}
	

</style>